import React from 'react';
import Intro from "../../../components/community/home/Intro";

const IntroPage = () => {
  return (
    <Intro />
  )
}

export default IntroPage